import { render } from "./ExpenseTypes.vue?vue&type=template&id=184d6b08"
import script from "./ExpenseTypes.vue?vue&type=script&lang=js"
export * from "./ExpenseTypes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__